import React, { Suspense, lazy, useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopButton from "./components/ScrollToTopButton";
import { ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import Footer from "./components/Footer/Footer";
import Privacy from "./components/Footer/Privacy";
import Terms from "./components/Footer/Terms";
import Copyright from "./components/Footer/Copyright";
import Data from "./components/Footer/Data";
import Refund from "./components/Footer/Refund";
import EmployeeManagementSystem from "./components/Services/EmployeeManagementSystem";
import PlanInfo from "./components/CreateAccountPlans/PlanInfo";
import CreateAccountForm from "./components/CreateAccountPlans/CreateAccountForm";
import SoftwareDetails from "./components/Solutions/SoftwareDetails";
import AppDetail from "./components/Solutions/AppDetail";
import ProjectManagementSystem from "./components/Services/ProjectManagementSystem";
import Pricing from "./components/Pricing/Pricing";
import StudyPointManagementSystem from "./components/Services/StudyPointManagementSystem";
import HRManagementSystem from "./components/Services/HRManagementSystem";
import AdmissionManagementSystem from "./components/Services/AdmissionManagementSystem";
import PayrollManagementSystem from "./components/Services/PayrollManagementSystem";
import SalesManagementSystem from "./components/Services/SalesManagementSystem";
import ClassroomManagementSystem from "./components/Services/ClassroomManagementSystem";
import TestSeriesManagemenSystem from "./components/Services/TestSeriesManagemenSystem";
import EcommerceManagementSystem from "./components/Services/EcommerceManagementSystem";
import BookShopManagementSystem from "./components/Services/BookShopManagementSystem";
import SchoolNewManagementSystem from "./components/Services/SchoolNewManagementSystem";
import CompnayManagementSystem from "./components/Services/CompnayManagementSystem";
import Clients from "./components/Clients/Clients";
import ContactPage from "./components/ContactPage/ContactPage";
import Navbar from "./Navbar/Navbar";
import Return from "./components/Footer/Return";
import { Infinity } from "ldrs/react";
import "ldrs/react/Infinity.css";
import Modules from "./components/Modules/Modules";
import CareerPost from "./components/CareerPost/CareerPost";


const BlogContent = lazy(() => import("./components/Blogs/BlogContent"));
const PostDetails = lazy(() => import("./components/Solutions/PostDetails"));
const Home = lazy(() => import("./components/Home/Home"));
const StudentInformationSystem = lazy(() =>
  import("./components/Services/StudentInformationSystem")
);
const OnlineAdmissionSystem = lazy(() =>
  import("./components/Services/OnlineAdmissionSystem")
);
const FeesManagementSystem = lazy(() =>
  import("./components/Services/FeesManagementSystem")
);
const OnlineExaminationSystem = lazy(() =>
  import("./components/Services/OnlineExaminationSystem")
);
const AttendanceManagementSystem = lazy(() =>
  import("./components/Services/AttendanceManagementSystem")
);
const HigherEducationSystem = lazy(() =>
  import("./components/Services/HigherEducationSystem")
);
const IncomeExpensesManagementSystem = lazy(() =>
  import("./components/Services/IncomeExpensesManagementSystem")
);
const InstituteManagementSoftware = lazy(() =>
  import("./components/Services/InstituteManagementSoftware")
);
const CollegeManagementSoftware = lazy(() =>
  import("./components/Services/CollegeManagementSoftware")
);
const SchoolManagementSoftware = lazy(() =>
  import("./components/Services/AcademyManagementSoftware")
);
const EnquiryManagementSystem = lazy(() =>
  import("./components/Services/EnquiryManagementSystem")
);
const ShippmentManagementSystem = lazy(() =>
  import("./components/Services/ShippmentManagementSystem")
);
const HostelManagmentSystems = lazy(() =>
  import("./components/Services/HostelManagmentSystems")
);
const Apps = lazy(() => import("./components/Apps/app"))
const Solutions = lazy(() => import("./components/Solutions/Solutions"));
const Blogs = lazy(() => import("./components/Blogs/Blogs"));
const Team = lazy(() => import("./components/Team/Team"));
const Plan = lazy(() => import("./components/Plan/Plan"));
const Login = lazy(() => import("./components/Login/Login"));
const Organization = lazy(() =>
  import("./components/Organization/Organization"));

const Schorlarship = lazy(() =>
  import("./components/Scholarship/Schorlarship")
);

const About = lazy(() => import("./components/About/About"));
const ContactUs = lazy(() => import("./components/ContactUs/ContactUs"));
const Become = lazy(() => import("./components/Become/Become"));
const SecondContact = lazy(() =>
  import("./components/SecondContact/SecondContact")
);
const Career = lazy(() => import("./components/Career/Career"));
const LoginPage = lazy(() => import("./components/LoginPage/LoginPage"));

function App() {
  const location = useLocation();
  const [loading, setLoading] = useState(false); 
  const hideNavbarFooterRoutes = ["/login-page"];
  const shouldHideNavbarFooter = hideNavbarFooterRoutes.includes(
    location.pathname
  );

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      <ScrollToTop />
      {!shouldHideNavbarFooter && <Navbar />}
      <div style={{ minHeight: "calc(100vh - 100px)" }}>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              backgroundColor: "#f5f5f5",
              color: "#1976d2",
              fontsize: "20px",
            }}
          >
            <Infinity
              size="85"
              stroke="8"
              strokeLength="0.15"
              bgOpacity="0.1"
              speed="1.3"
              color="rgb(38,157,215)"
            />
          </div>
        ) : (
          <Suspense fallback={<div> Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route
                path="/student-information-system"
                element={<StudentInformationSystem />}
              />
              <Route
                path="/online-admission-system"
                element={<OnlineAdmissionSystem />}
              />
              <Route
                path="/fees-management-system"
                element={<FeesManagementSystem />}
              />
              <Route
                path="/online-examination-system"
                element={<OnlineExaminationSystem />}
              />
              <Route
                path="/attendance-management-system"
                element={<AttendanceManagementSystem />}
              />
              <Route
                path="/higher-education-system"
                element={<HigherEducationSystem />}
              />
              <Route
                path="/income-expenses-management-system"
                element={<IncomeExpensesManagementSystem />}
              />
              <Route
                path="/institute-management-software"
                element={<InstituteManagementSoftware />}
              />
              <Route
                path="/college-management-software"
                element={<CollegeManagementSoftware />}
              />
              <Route
                path="/academy-management-software"
                element={<SchoolManagementSoftware />}
              />
              <Route
                path="/employee-management-system"
                element={<EmployeeManagementSystem />}
              />
              <Route
                path="/enquiry-management-software"
                element={<EnquiryManagementSystem />}
              />
              <Route
                path="/Shippment-management-software"
                element={<ShippmentManagementSystem />}
              />
              <Route
                path="/hostel-managment-system"
                element={<HostelManagmentSystems />}
              />
              <Route
                path="/project-management-system"
                element={<ProjectManagementSystem />}
              />
              <Route
                path="/study-point-management-system"
                element={<StudyPointManagementSystem />}
              />

              <Route
                path="/hr-management-system"
                element={<HRManagementSystem />}
              />

              <Route
                path="/admission-management-system"
                element={<AdmissionManagementSystem />}
              />

              <Route
                path="/payroll-management-system"
                element={<PayrollManagementSystem />}
              />

              <Route
                path="/sales-management-system"
                element={<SalesManagementSystem />}
              />

              <Route
                path="/classroom-management-system"
                element={<ClassroomManagementSystem />}
              />

              <Route
                path="/test-series-management-system"
                element={<TestSeriesManagemenSystem />}
              />

              <Route
                path="/ecommerce-management-system"
                element={<EcommerceManagementSystem />}
              />

              <Route
                path="/book-shop-management-system"
                element={<BookShopManagementSystem />}
              />

              <Route
                path="/student-information-system"
                element={<StudentInformationSystem />}
              />

              <Route
                path="/school-new-management-system"
                element={<SchoolNewManagementSystem />}
              />

              <Route
                path="/company-management-system"
                element={<CompnayManagementSystem />}
              />

              <Route path="/solutions" element={<Solutions />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blog/:title" element={<BlogContent />} />
              <Route path="/organization" element={<Organization />} />
              <Route path="/plan" element={<Plan />} />
              <Route path="/plan-details" element={<PlanInfo />} />
              <Route path="/next-page" element={<CreateAccountForm />} />
              <Route path="/login" element={<Login />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/about" element={<About />} />
              <Route path="/team" element={<Team />} />
              <Route path="/privacy-policy" element={<Privacy />} />
              <Route path="/terms-and-conditions" element={<Terms />} />
              <Route path="/copyright-policy" element={<Copyright />} />
              <Route path="/data" element={<Data />} />
              <Route path="/refund" element={<Refund />} />
              <Route path="/return" element={<Return />} />
              <Route path="/become" element={<Become />} />
              <Route path="/Career" element={<Career />} />
              <Route path="/second-contact" element={<SecondContact />} />
              <Route path="/post-details/:title" element={<PostDetails />} />
              <Route
                path="/software-details/:title"
                element={<SoftwareDetails />}
              />
              <Route path="/app-details/:title" element={<AppDetail />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/login-page" element={<LoginPage />} />
              <Route path="/modules" element={<Modules />} />
              <Route path="/freescholarship" element={<Schorlarship />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/contact-page" element={<ContactPage />} />
              <Route path="/career-post" element={<CareerPost />} />
              <Route path="/apps" element={<Apps />} />
            </Routes>
          </Suspense>
        )}
      </div>

      {!shouldHideNavbarFooter && <Footer />}
      <ScrollToTopButton />
      <ToastContainer />
    </>
  );
}

export default App;
